import { mutatorAction } from "satcheljs";

import { ITeamPermissionEntity } from "../../../sh-models";
import { TeamPermissionsStore } from "../store/TeamPermissionsStore";

export const setTeamPermissions = mutatorAction("setTeamPermissions", (permission: ITeamPermissionEntity) => {
    TeamPermissionsStore().permission = permission;
});